<template>
    <!-- Read from the API and never invented here. This is the number somebody quotes
         when they ring us about a hotel doing something unexpected, so a portal that
         has lost contact with the API shows nothing rather than the version it was
         built with — which would be an answer about the wrong half of the system. -->
    <span v-if="version" class="whitespace-nowrap text-xs opacity-70">v{{ version }}</span>
</template>

<script lang="ts" setup>
    import { onMounted, ref } from 'vue'

    import { useFetchStore } from '@/stores/fetch'

    const fetchStore = useFetchStore()
    const version    = ref('')

    onMounted(async () => {
        const { response, data } = await fetchStore
            .fetch('/version')
            .get()
            .json<{ version: string }>()

        if (response.value?.status === 200 && data.value?.version) {
            version.value = data.value.version
        }
    })
</script>
